import React, { useState } from "react";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import { Card, CardHeader, Typography,Stack,Box, Grid, CardContent,FormControl,FormHelperText,TablePagination } from "@mui/material";
import MaterialTypography from "../../../components/MaterialTypography";
import MaterialBox from "../../../components/MaterialBox";
import MaterialSelect from "../../../components/MasterSelect";
import MaterialInput from "../../../components/MaterialInput";
import MaterialButton from "../../../components/MaterialButton";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { Add, AddHome } from "@mui/icons-material";

function Action() {
  const rows = [
    { id: 1, type: 'DEFAULT', workflowStatus: 'Draft', finalStatus: false, remarks: 'Initial status of the Document', action: 'Not Removable' },
    { id: 2, type: 'DEFAULT', workflowStatus: 'Submitted for Approval', finalStatus: false, remarks: 'Documents submitted for Approvals', action: 'Not Removable' },
    { id: 3, type: 'DEFAULT', workflowStatus: 'Approval Completed', finalStatus: true, remarks: 'The final status of the Document in workflow', action: 'Not Removable' },
    { id: 4, type: 'CUSTOMIZE', workflowStatus: 'Waiting for Approval', finalStatus: false, remarks: '', action: '✅ ❌' },
  ];
  const [Mapdatas,setMapdatas] = useState([])


  const [Actiondata,setActiondata] = useState({
    actionname:'',
    actiontype:'',
    remarks:'',
    actionnameStatus:'unchecked',
    actiontypeStatus:'unchecked',
    remarksStatus:'unchecked',
  })

  const Final = [
    {value:'Approve',label:'Approve'},
    {value:'Reject ',label:'Reject'},
  ]

  console.log('Actiondata:',Actiondata);
  

  const handleActiondatachange = (event, selectEvent) => {
    let leaveState = { ...Actiondata };
    if (event?.target === undefined && selectEvent) {
      if (selectEvent.name === "actiontype") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");
        if (lengthRegex.test(event?.label) === true) {
          leaveState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          leaveState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      }
      leaveState[selectEvent.name] = event;
    } else {
      const changeAllowed = true;
      switch (event.target.name) {
      
        
        case "actionname":
          {
            const descriptionRegex = new RegExp("^[a-zA-Z0-9 ]{1,20}$");

            if (descriptionRegex.test(event.target.value?.trim())) {
              leaveState[event.target.name + "Status"] = "success";
            } else {
              leaveState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "remarks":
          {
            const descriptionRegex = new RegExp("^([\\s\\S]{2,50})$");

            if (descriptionRegex.test(event.target.value?.trim())) {
              leaveState[event.target.name + "Status"] = "success";
            } else {
              leaveState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
    
        default:
          break;
      }
      if (changeAllowed) {
        leaveState[event.target.name] = event.target.value;
      }
    }
    setActiondata(leaveState);
  };

  const checkAllFields = () => {
    let allowSubmit = false;
    if (
      Actiondata.actionnameStatus === "success" &&  
      Actiondata.actiontypeStatus === "success"   
   
    ) {
      allowSubmit = true;
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };

  const handlesubmit = ()=>{
    
      setMapdatas([
        ...Mapdatas,
        Actiondata
      ])
      
  }

  console.log("Mapdatas:",Mapdatas);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  // Handle page change
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  // Handle rows per page change
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0); // Reset to first page when changing row limit
  };

  return (
    <DashboardLayout>
      <Card
     
      >
     <CardHeader
        title={
          <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={2} padding={1}>
            <Stack direction="column" spacing={0}>
              <MaterialTypography variant="h5" fontWeight="medium">
                Workflow Actions
              </MaterialTypography>
            </Stack>
          </Stack>
        }
      />
      <CardContent>
        <MaterialBox sx={{marginLeft:'2%'}}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={3.2}>
              <MaterialBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                <MaterialTypography component="label" variant="caption" fontWeight="bold" textTransform="capitalize">
                Action Name <span style={{ color: 'red' }}>*</span>
                </MaterialTypography>
              </MaterialBox>
              <MaterialInput
                name="actionname"
                value={Actiondata.actionname}
                onChange={handleActiondatachange}
                error={Actiondata.actionnameStatus === 'error' ? true : false}
                success={Actiondata.actionnameStatus === 'success' ? true : false}
              />
              {Actiondata.actionnameStatus === 'error' && (
                <FormControl error>
                  <FormHelperText>
                    Action Name accept only Text and Numbers maximum 20 characters.
                  </FormHelperText>
                </FormControl>
              )}
            </Grid>
            <Grid item xs={12} sm={3.2}>
              <MaterialBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                <MaterialTypography component="label" variant="caption" fontWeight="bold" textTransform="capitalize">
                Action Type <span style={{ color: 'red' }}>*</span>
                </MaterialTypography>
              </MaterialBox>
              <MaterialSelect
                name="actiontype"
                value={Actiondata.actiontype}
                onChange={handleActiondatachange}
                options={Final.map((val) => ({
                  value: val.value,
                  label: val.label,
                }))}
                error={Actiondata.actiontypeStatus === 'error' ? true : false}
                success={Actiondata.actiontypeStatus === 'success' ? true : false}
              />
              {Actiondata.actiontypeStatus === 'error' && (
                <FormControl error>
                  <FormHelperText>Is Final is Mandatory.</FormHelperText>
                </FormControl>
              )}
            </Grid>
            <Grid item xs={12} sm={3.5}>
              <MaterialBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                <MaterialTypography component="label" variant="caption" fontWeight="bold" textTransform="capitalize">
                  Remarks
                </MaterialTypography>
              </MaterialBox>
              <MaterialInput
                multiline
                rows={3}
                name="remarks"
                value={Actiondata.remarks}
                onChange={handleActiondatachange}
                error={Actiondata.remarksStatus === 'error' ? true : false}
                success={Actiondata.remarksStatus === 'success' ? true : false}
              />
              {Actiondata.remarksStatus === 'error' && (
                <FormControl error>
                  <FormHelperText>Remarks Should accept maximum of 50 characters.</FormHelperText>
                </FormControl>
              )}
            </Grid>
            <Grid item xs={12} sm={2}>
              <MaterialBox mb={1} ml={0.5} lineHeight={0} display="flex" alignItems="center">
                <MaterialButton
                  variant="gradient"
                  color="dark"
                  startIcon={<Add />}
                  mb={0}
                  pb={0}
                  disabled={!checkAllFields()}
                  onClick={handlesubmit}
                >
                  Add
                </MaterialButton>
              </MaterialBox>
            </Grid>
          </Grid>
        </MaterialBox>
        <Box sx={{  padding: '5px', borderRadius: 1, mt: 3, mb: 2 }}>
          <Typography variant="body1" fontWeight={500} color="#3F51B5d4">
            List of Workflow Actions
          </Typography>
        </Box>

   
        <>
      <Table
        sx={{
          width: '100%',
          marginTop:'-2%',
          borderCollapse: 'collapse',
          tableLayout: 'fixed', // Ensures columns maintain fixed widths
        }}
        aria-label="workflow status table"
      >
        <TableHead>
          <TableRow sx={{ backgroundColor: '#dfe6e9' }}>
            <TableCell sx={{ fontWeight: 'bold', color: '#2c3e50', width:'20%' }}>ID</TableCell>
            <TableCell align="left" sx={{ fontWeight: 'bold', color: '#2c3e50',width:'20%' }}>Type</TableCell>
            <TableCell align="left" sx={{ fontWeight: 'bold', color: '#2c3e50', width: '30%' }}>Workflow Action</TableCell>
            <TableCell align="left" sx={{ fontWeight: 'bold', color: '#2c3e50', width:'30%' }}>Action Type</TableCell>
            <TableCell align="left" sx={{ fontWeight: 'bold', color: '#2c3e50', width:'0%' }}>Remarks</TableCell>
            <TableCell align="center" sx={{ fontWeight: 'bold', color: '#2c3e50', width:'10%'}}>Action</TableCell>
          </TableRow>
       

        <TableBody>
          {Mapdatas.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => (
            <TableRow
              key={row.id}
              sx={{
                backgroundColor: index % 2 === 0 ? '#f8f9fa' : '#ffffff',
                '&:hover': { backgroundColor: '#ecf0f1', cursor: 'pointer' },
              }}
            >
              <TableCell component="th" scope="row">{page * rowsPerPage + index + 1}</TableCell>
              <TableCell align="left">{row?.type}</TableCell>
              <TableCell align="left">{row.actionname}</TableCell>
              <TableCell align="left">{row.actiontype?.value}</TableCell>
              <TableCell align="left">{row.remarks}</TableCell>
              <TableCell align="center">
                <EditIcon sx={{ mr: 1, cursor: 'pointer', color: '#1e88e5', '&:hover': { color: '#1565c0' } }} />
                <DeleteIcon sx={{ cursor: 'pointer', color: '#e53935', '&:hover': { color: '#b71c1c' } }} />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
        </TableHead>
      </Table>

      {/* Pagination - Now aligned properly */}
      <Box sx={{ display: 'flex', justifyContent: 'end', padding: '1px' }}>
      <TablePagination
  component="div"
  count={Mapdatas.length}
  rowsPerPage={rowsPerPage}
  page={page}
  onPageChange={handleChangePage}
  onRowsPerPageChange={handleChangeRowsPerPage}
  rowsPerPageOptions={[10]} // Hides the rows-per-page dropdown
  labelRowsPerPage="" // Removes the "Rows per page" label
  sx={{
    display: 'flex',
    justifyContent: 'end',
    padding: '10px',
  }}
/>

      </Box>
    </>
      </CardContent>
      </Card>
    </DashboardLayout>
  );
}

export default Action;
